<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div  v-show="stateArrow" id="leftBox" class="leftBox" style="width: 206px">
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
               <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :label="$t('VehicleManagement.maintainReminder')" name="first">
                        <MaintenanceReminder ref='TabRepair'></MaintenanceReminder>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('VehicleManagement.serialBill')" name="second">
                        <MaintenanceOrder ref='TabMaintenance'></MaintenanceOrder>
                    </el-tab-pane>
                </el-tabs> 
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaintenanceManagement from "./MaintenanceManagement.js";
export default MaintenanceManagement;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>

